<script>
  export default {
    name: 'filter-render',
    inject: ['store'],
    props: {
      node: {
        type: Object,
        default: {
          props: {}
        }
      }
    },
    data () {
      return {
        saveConditionList: {}
      }
    },
    computed: {
      conditionList () {
        return this.store.queryParams?.conditionList || {}
      }
    },
    methods: {
      // filter 查询回调
      filterDataHandle () {
        this.store._search()
      },
      // 单行文本多行文本可以输入空格
      inputTrim (event, key) {
        const {search} = event
        if (!this.conditionList[key]) {
          this.conditionList[key] = {}
        }
        this.conditionList[key].value = search
        if (!this.saveConditionList[key]) {
          this.saveConditionList[key] = true
          this.conditionList[key].apiName = this.conditionList[key].apiName || key
          this.$set(this.conditionList, key, this.conditionList[key])
        }
      },
      chenggong (value) {
        console.log(value)
        this.$set(this.conditionList, value.apiName, value)
      }
    },
    render (h) {
      let {viewContent, props} = this.node
      return (
        <filter-search
          {...props}
          query={this.store.queryParams}
          saveRef={this.store.saveRef}
          on-search={this.filterDataHandle}
        >
          <template slot="search">
            {
              viewContent && viewContent.map((node, idx) => {
                console.log(node.apiName, '===apiName')
                return (
                  node?.slots?.filter && node.slots.filter
                    ? node.slots.filter(h, {field: node})
                    : <filter-item label={node.name}>
                      {
                        node?.slots?.['filter_content']
                          ? node?.slots?.['filter_content']
                          : <filter-item-render
                            key={node.apiName}
                            conditionList={this.conditionList}
                            filterFieldItem={node}
                            on-fetch-data-handle-event={this.filterDataHandle}
                            on-input-trim={val => this.inputTrim(val, node.apiName)}
                            on-input-change={this.chenggong}
                          />
                      }
                    </filter-item>
                )
              })
            }
          </template>
        </filter-search>
      )
    }
  }
</script>
